import {Trans} from '@lingui/macro';
import {Divider, Button, Grid} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import React from 'react';
import ChoiceGrid from '../component/ChoiceGrid';

const ChoicePage = (props) => {
  return (
    <>
      {/* Contenedor superior: botón + título centrado */}
      <Grid container alignItems="center" style={{position: 'relative'}}>
        {/* Botón alineado a la izquierda */}
        <Grid item>
          <Button
            startIcon={<ChevronLeftIcon />}
            color="primary"
            onClick={() => props.setIsChoiceActive({active: false})}
            style={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              marginLeft: '16px',
            }}>
            <Trans>Volver al material</Trans>
          </Button>
        </Grid>

        {/* Título centrado */}
        <Grid item xs={12}>
          <h2 className="TitleGrid">
            <Trans>Choice</Trans>
          </h2>
        </Grid>
      </Grid>

      <Divider variant="middle" style={{marginBottom: 10}} />

      {/* Contenido principal */}
      <ChoiceGrid props={props} />
    </>
  );
};

export default ChoicePage;
